import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  AfterContentChecked,
  AfterViewInit
} from '@angular/core';
import {Property} from "../../../model/property";
import {Package} from "../../../model/package";
import {PropertyFormComponent} from "../property-form/property-form.component";
import {ProductsContainerComponent} from "../products-container/products-container.component";
import {User} from "../../../model/user";
import {Document} from "../../../model/document";
import {Order} from "../../../model/order";
import {Router} from "@angular/router";
import {ProductService} from "../../../service/product.service";
import {AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ModalComponent} from "../../modal/modal.component";
import {DropzoneConnectComponent} from "../../dropzone-connect/dropzone-connect.component";
import {SavedProperty} from "../../../model/savedProperty";
import {BeneficiaryAddress} from "../../../model/beneficiaryAddress";
import {LandregisterfolioUtils} from "../../../utils/LandregisterfolioUtils";
import {BillingAdress} from "../../../model/billingAdress";
import {DownloadService} from "../../../service/download.service";
import {PlatformProfile} from "../../../model/platformprofile";
import {animate, style, transition, trigger} from "@angular/animations";
import * as $ from 'jquery';
import {ContactService} from "../../../service/contact.service";
import { LoginIdService } from "../../../service/login-id.service";
import {AuthorityService} from "../../../service/authority.service";
import {v4 as uuid} from "uuid";
import {Country} from "../../../model/country";
import {CountryService} from "../../../service/country.service";
import StaticData from "../../../utils/static-data";

@Component({
  selector: 'app-new-order-page-connect',
  templateUrl: './new-order-page-connect.component.html',
  styleUrls: ['./new-order-page-connect.component.css'],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0, 'margin-top': '0'}),
            animate('0.4s ease',
              style({ height: '*', opacity: 1 , 'margin-top': '*'}))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: '*', opacity: 1 , 'margin-top': '*'}),
            animate('0.4s ease',
              style({ height: 0, opacity: 0 ,'margin-top': '0'}))
          ])
      ],
    )
  ],
  encapsulation: ViewEncapsulation.None
})
export class NewOrderPageConnectComponent implements OnInit, AfterContentChecked, AfterViewInit {


  property: Property;
  informationProperty: Property;
  properties: Array<Property> = new Array<Property>();
  savedProperties: Array<SavedProperty> = new Array<SavedProperty>();
  packages: Array<Package>;
  @ViewChild(PropertyFormComponent) propertyFormComponent: PropertyFormComponent;
  @ViewChild(ProductsContainerComponent) productsContainerComponent: ProductsContainerComponent;
  @ViewChild('authorityDropzone') authorityDropzoneComponent: DropzoneConnectComponent;
  @ViewChild('subAuthorityDropzone') subAuthorityDropzoneComponent: DropzoneConnectComponent;
  @ViewChild('addPropertyModal') addPropertyModalComponent: ModalComponent;
  @ViewChild('mandateModal') mandateModalComponent : ModalComponent;
  displayInfo: boolean = false;
  user: User;
  docInfo: string;
  extraDocuments: boolean = false;
  foundSavedProperty: boolean = false;
  displayAuthorizedDropzone: boolean = true;
  legitimateInterest: string = "init";
  files: Array<any>;
  documents: Array<Document> = new Array<Document>();
  toNextPage: boolean = false;
  errorMsg: string;
  addPropertyErrorMsg: string;
  cachedOrders: Order[];
  showAddPropertyModal: boolean = false;
  showMandateModal: boolean = false;
  showPriceInformationModal: boolean = false;
  showPropertyInformationModal: boolean = false;
  showMissingPropertyError: boolean = false;
  loadingSavedProperties: boolean = false;
  billingForm: UntypedFormGroup;
  beneficiaryForm: UntypedFormGroup;
  countries: Array<Country> = [];
  searchText:string;
  platformProfile: PlatformProfile;
  products;
  selectedMandateId: number;

  isAllowedToOrder: boolean = true;

  newDocumentNames: Array<string> = ["Leitungsauskünfte","Bauaktenarchivbesuche","Objektaufnahme"];

  constructor(private router: Router, private productService: ProductService, private formBuilder: UntypedFormBuilder,
              private downloadService: DownloadService, private loginIdService: LoginIdService,
              private cd: ChangeDetectorRef, private contactService: ContactService, private authorityService: AuthorityService,
              private countryService: CountryService) {
    let legitimateInterest = JSON.parse(sessionStorage.getItem("legitimate_interest"));
    this.legitimateInterest = legitimateInterest ? legitimateInterest : this.legitimateInterest;
    this.properties = JSON.parse(sessionStorage.getItem("new_order_properties"));
    if(!this.properties){
      this.properties = new Array<Property>();
    }
  }


  async ngOnInit(): Promise<void> {
      await this.loginIdService.loginServiceInitialized$.toPromise();
      this.isAllowedToOrder = this.loginIdService.isAdmin() || this.loginIdService.canOrder();
      this.products = JSON.parse(sessionStorage.getItem("products"));
      this.initPlatformProfile();
      this.loginIdService.loadingSavedPropertiesChanged$.subscribe(isLoading => {
          if(!isLoading){
              this.initPlatformProfile()
          }
          this.loadingSavedProperties = isLoading;
      })

      this.selectedMandateId = JSON.parse(sessionStorage.getItem("mandate_id"));

      this.foundSavedProperty = false;

      if (this.platformProfile.mandate.length > 0 && !this.selectedMandateId) {
          this.showMandateModal = true;
      }

      if (!this.property) {
          this.property = new Property();
      }

      this.user = JSON.parse(sessionStorage.getItem("user"));

      this.countries = this.countryService.getCountries();

      this.billingForm = this.formBuilder.group({
          firma: new UntypedFormControl(null, Validators.required),
          street: new UntypedFormControl(null, Validators.required),
          plz: new UntypedFormControl(null, Validators.compose([
              Validators.required
          ])),
          town: new UntypedFormControl(null, Validators.required),
          country: new UntypedFormControl(StaticData.DEFAULT_COUNTRY, Validators.required),
      });

      this.beneficiaryForm = this.formBuilder.group({
          firma: new UntypedFormControl(null),
          street: new UntypedFormControl(null),
          plz: new UntypedFormControl(null),
          town: new UntypedFormControl(null),
          country: new UntypedFormControl(StaticData.DEFAULT_COUNTRY, Validators.required),
      });

  }

  ngAfterViewInit(): void {
    if(this.properties.length > 0){
      this.property = this.properties[0]
      this.onPropertySelection(this.property);
    }

    if (!this.property)
      this.property = new Property();

    this.cd.detectChanges()

  }

  ngAfterContentChecked(): void {
    this.cd.detectChanges();
  }

    /**
     * Initializes the platform profile and its corresponding saved properties from the session storage
     */
  private initPlatformProfile(): void {
      this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));
      if (this.platformProfile) {
          this.savedProperties = this.platformProfile.properties;
      }
  }

  getLongName(shortName) {
    let result;
    if(this.products !== null){
      this.products.forEach(p=>{
        if(p.nameShort === shortName)
          result = p.name_long.substr(0,26);
        return;
      });
    }
    return result ? result : shortName;
  }

  setDocuments(documents) {
    let documentObjects = []
    documents.forEach(function (document) {
      documentObjects.push(new Document(document));
    })
    this.getProductContainer().documents = documentObjects;
  }

  hasError(control: AbstractControl): boolean {
    return (control?.invalid && (control?.touched));
  }

  markInvalidInputs(form: UntypedFormGroup){
    Object.keys(form.controls).forEach(key => {
      if(form.get(key) instanceof UntypedFormControl){
        form.get(key).markAsTouched()
      }
      if(form.get(key) instanceof UntypedFormArray){
       form.get(key).markAllAsTouched()
      }
    })
  }

  async addAuthority() {
    if(this.isFormValid()){
      let propertyForm = this.propertyFormComponent.propertyForm;
      let billingAdress = this.billingForm.value;
      let beneficiaryAdress = this.beneficiaryForm.value;
      if(this.isBeneficiaryAddressEmpty(beneficiaryAdress)){
        beneficiaryAdress = billingAdress;
      }
      if(this.propertyFormComponent.property.id === undefined){
        this.property = propertyForm.value;
        if(!this.property.name){
          this.property.name = this.property.town + ", " + this.property.street + " " + this.property.house_number;
        }
        this.property.billingAdress = billingAdress;
        this.property.beneficiaryAddress = beneficiaryAdress;
        this.property.documents = [];
        this.authorityDropzoneComponent.authorityMap.set(this.property,this.authorityDropzoneComponent.files[0]);
        this.subAuthorityDropzoneComponent?.authorityMap.set(this.property,this.subAuthorityDropzoneComponent?.files[0]);
        this.property.id = uuid();
        this.authorityDropzoneComponent.uploadAuthorityMap(this.property);
        this.subAuthorityDropzoneComponent?.uploadAuthorityMap(this.property);

        this.addPropertyToThisProperties(this.property)
        this.getPropertyInformation(this.property);
        this.addPropertyErrorMsg = null;

      }
      if(this.addPropertyErrorMsg === null){
          this.resetForms();
      }

    }
    if(this.addPropertyErrorMsg === null){
      this.closeModal();
      this.onPropertySelection(this.properties[this.properties.length-1]);
    }
  }

  getProductContainer() {
      return this.productsContainerComponent;
  }

  @HostListener('window:beforeunload', ['$event'])
  storeInSession() {
    sessionStorage.setItem("new_order_properties",JSON.stringify(this.properties));
  }

  compareLists(listA, listB) {
    if (listA.length != listB.length)
      return false;

    listA.forEach(function (elem) {
        if (!listB.includes(elem))
          return false;
      }
    )
    return true;
  }

  displayInfoEvent(docName) {
    this.addInfos(docName);
  }

  addInfos(name) {
    this.productService.getInfoProductCommand(name).subscribe(
      data => {
        this.docInfo = data
        this.displayInfo = true;
      },
      error => {
        console.log(error);
      }
    );
  }
  async logout() {
    await this.loginIdService.loggedOut(true);
  }

  resetForms(){
    let propertyForm = this.propertyFormComponent.propertyForm;

    this.property = new Property();
    this.productsContainerComponent.documents = [];
    propertyForm.reset();

    this.billingForm.reset({
      country: StaticData.DEFAULT_COUNTRY
    });
    this.beneficiaryForm.reset({
      country: StaticData.DEFAULT_COUNTRY
    });

    this.authorityDropzoneComponent.deleteAttachment(0);
    this.subAuthorityDropzoneComponent?.deleteAttachment(0);
  }

  onPropertySelection(property){
    this.property = property;
    this.getProductContainer().documents = this.property.documents;
    this.productsContainerComponent.resetSelectedPackage();
    this.productsContainerComponent.findNextDocumentPackage();
    this.getProductContainer().documentEntryDate = new Map();
    if(property.savedId) {
      // Note: comment in again to activate the lastOrderedWhen function
      // this.getProductContainer().getDocumentsBySavedPropertyId(property.savedId)
      this.getProductContainer().isSavedProperty = true;
      this.getProductContainer().savedId = property.savedId;
    }
    else{
      this.getProductContainer().isSavedProperty = false;
      this.getProductContainer().savedId = undefined;
    }
    if(this.property.id){
      this.showMissingPropertyError = false;
      this.productsContainerComponent.shouldOpenModal = true;
    }
  }

  checkIfPropertyIsSelected(){
    if(!this.property.id){
      this.showMissingPropertyError = true;
      this.productsContainerComponent.documents = [];
      this.productsContainerComponent.resetSelectedPackage();
      this.productsContainerComponent.shouldOpenModal = false;
    }
    else{
        this.productsContainerComponent.shouldOpenModal = true;
    }
  }


  /**
   * Removes the provided property from this.properties and deletes corresponding authorities from the indexedDb
   *
   * @param property Property which should be removed from this.properties
   */
  public async removePropertyFromPropertyList(property): Promise<void> {
    this.properties.forEach((p, index) => {
      if (p === property) {
        this.properties.splice(index, 1);
        this.productsContainerComponent.resetSelectedPackage();
        if (this.isPropertyLoaded(property)) {
          this.onPropertySelection(new Property());
        }
      }
    });

    await this.authorityService.removeAuthoritiesFromIndexedDbByProperty(property);
  }

  isPropertyLoaded(property){
    return this.property === property;
  }

    /**
     * Checks if the beneficiary form values are partially filled.
     * Returns false if all values are truthy or all values are falsy
     * Returns true if at least one of the fields is truthy
     * Falsy value are 'false', 'null', 'undefined' or and empty string
     *
     * @returns True if the beneficiary form is partially filled else false
     */
    isBeneficiaryFormPartiallyFilled(): boolean {
        if (!this.beneficiaryForm) {
            return false;
        }

        const beneficiaryFormValue = this.beneficiaryForm.value;
        const { firma, street, plz, town } = beneficiaryFormValue;

        //Return false if all fields are filled
        if(firma && street && plz && town){
            return false;
        }

        //Return true if at least one field is filled and false if none is filled
        return firma || street || plz || town;
    }

    /**
     * Checks if a specific beneficiary address is empty
     * @param beneficiaryAddress BeneficiaryAddress that should be checked
     */
    isBeneficiaryAddressEmpty(beneficiaryAddress) {
        const { name, street, plz, town } = beneficiaryAddress;
        return !(name || street || plz || town);
    }

  isFormValid(){
    let propertyForm = this.propertyFormComponent.propertyForm;


    this.markInvalidInputs(propertyForm)
    this.markInvalidInputs(this.billingForm)
    this.markInvalidInputs(this.beneficiaryForm)

    $('#authority-modal .modal-card-body').animate({
      scrollTop: 0
    }, 'slow');

    if (!propertyForm.valid) {
      this.addPropertyErrorMsg = "Bitte geben Sie alle relevanten Objektdaten an."
      return false;
    }
    else if(!this.billingForm.valid){
      this.addPropertyErrorMsg = "Bitte geben Sie den Rechnungsempfänger an."
      return false;
    }
    else if(this.isBeneficiaryFormPartiallyFilled()){
      this.addPropertyErrorMsg = "Bitte vervollständigen Sie den Leistungsempfänger."
      return false;
    }
    else if(!this.beneficiaryForm.valid){
        this.addPropertyErrorMsg = "Bitte geben Sie korrekte Daten für den Leistungsempfänger an."
        return false;
    }
    else if(this.authorityDropzoneComponent.files.length < 1 || (this.subAuthorityDropzoneComponent?.files.length < 1 && this.displayAuthorizedDropzone)){
      this.addPropertyErrorMsg = "Bitte fügen Sie die benötigten Vollmachten hinzu."
      return false;
    }
    else{
      this.addPropertyErrorMsg = null;
      return true;
    }

  }

  closeModal(){
    this.addPropertyErrorMsg = null;

    this.resetForms();

    if(this.properties.length > 0){
      this.property = this.properties[0]
      this.onPropertySelection(this.property);
    }

    this.showAddPropertyModal = false;
  }

  openModal(){
    this.resetForms();
    this.showAddPropertyModal = true;
  }

  openMandateModal(val: boolean){
    this.showMandateModal = val;
  }

  openPriceInformationModal(){
    this.showPriceInformationModal = true;
  }

  openPropertyInformationModal(informationProperty){
    this.showPropertyInformationModal = true;
    this.informationProperty = informationProperty;
  }

  hasEveryPropertyOneDoc(){
    let property = this.properties.find(p => p.documents.length < 1);
    if(property === undefined){
      this.errorMsg = null;
      this.storeInSession();
      this.router.navigate(["/cart"]);
    }
    else{
      this.errorMsg = "Bitte fügen Sie für das Objekt "+ property.name +": " + property.town + ", " + property.street + " mindestens ein Dokument hinzu oder entfernen Sie es"
    }
  }

  back(){
    this.router.navigate(["/home"]);
  }


  setFoundSavedProperty() {
    let table = document.getElementById("result-table");
    if(table !== null){
      let totalRowCount = table.querySelectorAll("tbody tr").length;
      this.foundSavedProperty = totalRowCount - 1 !== 0;
    }
  }


  addSavedPropertyToOrder(savedProperty){
    let foundProperty = this.properties.find(p => p.id === savedProperty.id);
    if(foundProperty === undefined){
      let property = new Property();
      let subfix = savedProperty.name;
      if(subfix === null || subfix === ""){
        subfix = savedProperty.town + ", " + savedProperty.street;
      }
      property.name = subfix;
      property.id = savedProperty.id
      property.savedId = savedProperty.property.savedId;
      property.savedId = savedProperty.id;
      property.zip = savedProperty.zip
      property.town = savedProperty.town;
      property.house_number = savedProperty.house_number;
      property.street = savedProperty.street;
      property.contactMail = savedProperty.contactMail;

      property.landregisterfolios = LandregisterfolioUtils.copyForNewOrder(savedProperty.landregisterfolios);

      if(savedProperty.beneficiariesAddress != null){
        let beneficiaryAddress = new BeneficiaryAddress();
        beneficiaryAddress.firma = savedProperty.beneficiariesAddress.beneficiary;
        beneficiaryAddress.street = savedProperty.beneficiariesAddress.street;
        beneficiaryAddress.plz = savedProperty.beneficiariesAddress.zip;
        beneficiaryAddress.town = savedProperty.beneficiariesAddress.town;
        beneficiaryAddress.country = savedProperty.beneficiariesAddress.country;
        property.beneficiaryAddress = beneficiaryAddress;
      }
      if(savedProperty.billingAddress != null){
        let billingAddress = new BillingAdress();
        billingAddress.name = savedProperty.billingAddress.recipient;
        billingAddress.firma = savedProperty.billingAddress.firma;
        billingAddress.street = savedProperty.billingAddress.street;
        billingAddress.town = savedProperty.billingAddress.town;
        billingAddress.plz = savedProperty.billingAddress.zip;
        billingAddress.country = savedProperty.billingAddress.country;

        property.billingAdress = billingAddress;
      }
      this.addPropertyToThisProperties(property)
      this.getPropertyInformation(property);
      this.searchText = "";
      this.onPropertySelection(property);
    }
  }

  /**
   * Retrieves and updates information (isTeilunObtainableOnSite, state) for the specified property.
   *
   * @param property Property for which its information should be updated
   */
  public getPropertyInformation(property: Property): void {
    // Find the index of the given property in the this.properties array
    const propertyIndex = this.properties.findIndex(prop => prop.id === property.id);

    // If the property is not found exit early
    if (propertyIndex === -1) {
      return;
    }

    // Fetch the country state name for the property
    this.contactService.getCountryStateName(property.town, property.zip).subscribe({
      next: (countryStateName) => {
        this.properties[propertyIndex].state = countryStateName;
      }
    })

    // Fetch the service information for the property (to retrieve isTeilunObtainableOnSite)
    this.contactService.getPropertyServiceInformationForTeilun(property).subscribe({
      next: (serviceInformation) => {
        if (serviceInformation !== undefined && serviceInformation !== null) {
          this.properties[propertyIndex].isTeilunObtainableOnSite = serviceInformation.onSiteObtaining;
        }
      },
      error: () => {
        // If an error occurs set a default value for isTeilungObtainableOnSite
        this.properties[propertyIndex].isTeilunObtainableOnSite = true;
      }
    })
  }

  setMandate(mandate){
    sessionStorage.setItem("mandate_id", JSON.stringify(mandate.id));
    this.selectedMandateId = mandate.id;
    this.mandateModalComponent.closeModal();
  }

  getSelectedMandate(){
    return this.selectedMandateId;

  }

  getMandateNameById() {
    if (this.router.url === '/new_order') {
      let id = this.getSelectedMandate();
      // hier nur abfrage wenn mandat id nicht null ist
      if (id) {
        if (this.platformProfile) {
          let mandate = this.platformProfile.mandate.find(m => m.id === id);
          if (mandate !== undefined) {
            return mandate.name;
          } else {
            return "";
          }
        } else
          return "";
      }
    }
  }

  /**
   * Download a PDF authority template for a specific authority type depending on the selected legitimateInterest
   */
  public downloadAuthorityPdfTemplate(): void{
    const authorityType = this.legitimateInterest === "owner" ? "DIRECT" : "REPRESENTATIVE"
    this.downloadService.downloadAuthorityPdfTemplate(authorityType);
  }

  getSelectedProperty(){
    this.productsContainerComponent.selectedProperty = this.property;
  }

  addPropertyToThisProperties(property: Property){
    this.properties.push(property);
    this.showMissingPropertyError = false;
    this.productsContainerComponent.shouldOpenModal = true;
  }

    /**
     * Handles when a user wants to navigate to the next page from the new order page
     * Handles if the user is not allowed to order
     * Handles if not all information regarding products are set
     */
    public handleSummaryClickEvent(event: any): void{
        if(!this.checkIfAllProductInformationArePresent()){
            event.stopPropagation();
            return;
        }
        if(!this.isAllowedToOrder){
            this.scrollToNotification();
            return;
        }
        this.hasEveryPropertyOneDoc();
    }

    /**
     * Checks if all information regarding products are available inside the products container component
     */
    public checkIfAllProductInformationArePresent(): boolean{
        return this.productsContainerComponent && this.productsContainerComponent.areAllProductInformationPresent()
    }

  /**
   * Toggles the visibility of the authorized dropzone based on the selected value
   *
   * @param event Event triggered by the select input from the UI
   */
  public toggleAuthorityDropzone(event: any): void{
      this.displayAuthorizedDropzone = event.target.value !== "owner";
    }

    /**
     * Returns the type of the authority ('Vollmacht' or 'Vollmachtkette') that has to be provided based on the legitimate interest
     *
     * @return 'Vollmacht' if the legitimate interest is 'owner', 'Vollmachtkette' if the legitimate interest ist 'authorized'.
     */
    public getAuthorityType(): string {
      if (this.legitimateInterest === 'owner') {
        return 'Vollmacht';
      } else if (this.legitimateInterest === 'authorized') {
        return 'Vollmachtkette';
      }
    }

    /**
     * Returns the text for the pdf template link based on the legitimate interest.
     *
     * @return 'Muster Eigentümer' if the legitimate interest is 'owner', 'Muster Eigentümervertreter' if the legitimate interest is 'authorized'
     */
    public getPdfTemplateText(): string {
      if (this.legitimateInterest === 'owner') {
        return 'Muster Eigentümer';
      } else if (this.legitimateInterest === 'authorized') {
        return 'Muster Eigentümervertreter';
      }
    }

  scrollToNotification() {
    window.scrollTo({top: 0, behavior: "smooth"});
  }

  protected readonly window = window;
}
